// import { Fancybox } from '@fancyapps/ui';

export default function Header() {
  // // Открытие формы при наличии хеша
  // const orderModal = document.querySelector('#order_a_callback');

  // if (orderModal) {
  //   // мне кажется здесь ошибка и hash должен быть #callback, либо выше должно быть #appointment
  //   if (window.location.hash === '#appointment') {
  //     Fancybox.show([
  //       {
  //         src: orderModal,
  //         type: 'html',
  //       },
  //     ]);
  //   }
  // }

  // Открытие доп. окна с адресами
  const openMoreAddresses = document.querySelectorAll('.more-address-link');
  if (openMoreAddresses) {
    openMoreAddresses.forEach((openMoreAddress) => {
      openMoreAddress.addEventListener('click', function moreAddress(e) {
        e.preventDefault();
        const moreAddressCont = document.querySelector('.more-address');
        if (moreAddressCont) {
          moreAddressCont.classList.toggle('more-address-open');
        }
      });
    });
  }
  // Закрытие доп. окна с адресами
  const closeMoreAddress = document.querySelector('.more-address-close');
  if (closeMoreAddress) {
    closeMoreAddress.addEventListener('click', function moreAddress() {
      const moreAddressCont = document.querySelector('.more-address');
      if (moreAddressCont) {
        moreAddressCont.classList.remove('more-address-open');
      }
    });
  }

  // Открытие доп. окна с поиском
  const openSearchBtns = document.querySelectorAll('.search-eye-cont .search-link');
  if (openSearchBtns) {
    openSearchBtns.forEach((openSearchBtn) => {
      openSearchBtn.addEventListener('click', function openSearch() {
        const searchCont = document.querySelector('.header-search');
        if (searchCont) {
          searchCont.classList.add('header-search-open');
        }
      });
    });
  }

  // Закрытие доп. окна с поиском
  const closeSearchBtn = document.querySelector('.header-search-close');
  if (closeSearchBtn) {
    closeSearchBtn.addEventListener('click', function closeSearch() {
      const searchCont = document.querySelector('.header-search');
      if (searchCont) {
        searchCont.classList.remove('header-search-open');
      }
    });
    document.onkeydown = function (e) {
      if (e.keyCode == 27) {
        const searchCont = document.querySelector('.header-search');
        if (searchCont) {
          searchCont.classList.remove('header-search-open');
        }
      }
    };
  }

  // Открытие выпадающего списка городов по клику
  const hoverCityDropdownArrows = document.querySelectorAll('.city-select .header-hover-dropdown .hover-dropdown-head');
  if (hoverCityDropdownArrows) {
    hoverCityDropdownArrows.forEach((hoverCityDropdownArrow) => {
      hoverCityDropdownArrow.addEventListener('click', function openSecondLevel(e) {
        const hoverContainer = this.closest('.header-hover-dropdown');
        hoverContainer.classList.toggle('header-hover-dropdown-open');
      });
    });
  }

  window.addEventListener('click', (event) => {
    const target = event.target;
    const otherClickCity = document.querySelectorAll('.city-select .click-other-city');
    if (otherClickCity) {
      otherClickCity.forEach((otherCl) => {
        const parentClose = otherCl.closest('.header-hover-dropdown-open');
        if (parentClose) {
          if (!target.closest('.click-other-city') && !target.closest('.city-select')) {
            parentClose.classList.remove('header-hover-dropdown-open');
          }
        }
      });
    }
  });

  // Открытие выпадающего списка по клику
  // const hoverDropdownArrows = document.querySelectorAll('.header-hover-dropdown .hover-dropdown-arrow');
  const hoverDropdownArrows = document.querySelectorAll('.header-hover-dropdown .mob-menu-arrow-container');
  if (hoverDropdownArrows) {
    hoverDropdownArrows.forEach((hoverDropdownArrow) => {
      hoverDropdownArrow.addEventListener('click', function openSecondLevel(e) {
        if (e.target.closest('.city-select')) {
          return;
        }
        const hoverContainer = this.closest('.header-hover-dropdown');
        hoverContainer.classList.toggle('header-hover-dropdown-open');
      });
    });
  }

  // Открытие выпадающего списка по клику в меню второго уровня
  const hoverDropdownArrowsLevel2 = document.querySelectorAll('.hover-menu-level3 .arrow-container');
  if (hoverDropdownArrowsLevel2) {
    hoverDropdownArrowsLevel2.forEach((hoverDropdownArrow) => {
      hoverDropdownArrow.addEventListener('click', function openSecondLevel(e) {
        const hoverContainer = this.closest('.hover-menu-level3');
        hoverContainer.classList.toggle('hover-menu-level3-open');
      });
    });
  }

  const openMenuBurger = document.querySelector('.burger');
  if (openMenuBurger) {
    openMenuBurger.addEventListener('click', function openMenu(e) {
      const menuContainer = document.querySelector('.mob-header-open-container');
      menuContainer.classList.toggle('mob-header-open-container-open');
      document.querySelector('body').classList.add('no-scroll');
    });
  }
  const closeMenu = document.querySelector('.mob-header-close');
  if (closeMenu) {
    closeMenu.addEventListener('click', function closeMenu(e) {
      const menuContainer = document.querySelector('.mob-header-open-container-open');
      if (menuContainer) {
        menuContainer.classList.toggle('mob-header-open-container-open');
        document.querySelector('body').classList.remove('no-scroll');
      }
    });
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1023) {
      closeMenu.click();
    }
  });
}
